import React from 'react'
import { Table } from '../../common/molecules'
import SearchBar from '../../tailwind/molecules/SearchBar'

const TableData = ({  individualList = false, headers = '', loading = false, steps = true, type = '', IconHandler = () => {}, inputClasses = '',tableschema = '', Classes ='', arrowChange = false,  IndividualData = [], onSearchHandler, tableClasses='', tableHeaderClasses = '' }) => {
  let key = (arrowChange ? 'team' : 'individual')
  return (
    <div className={Classes}>
    { individualList &&
      <div >
      <SearchBar classes='mb-4 h-12' closeIcon={true} CloseIconHandler={(e) => IconHandler(e , key)} placeholder='Search by employee name, employee id and email id' inputClasses={`px-3 rounded-md pt-4 pb-3 pl-10 text-base  placeholder-gray-100 leading-4 ${inputClasses}`}handler={(e) => onSearchHandler(e, key)}/>
      <Table
      headers={headers}
      loading={loading}
      type={type}
      step={steps}
      data={IndividualData}
      tableClasses='alternate_gray200_color'
      classes={`rounded-md ${tableClasses}`}
      tableHeaderClasses={tableHeaderClasses}
      tableschema={tableschema}
      />
      </div>
    }  
    </div>
  )
}

export default TableData